import React, { useState, useRef, useEffect } from 'react';

function OTPVerification({ phoneNumber, onVerify, onBack }) {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);

  useEffect(() => {
    // Focus first input on mount
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (index, value) => {
    // Only allow numbers
    if (value && !/^\d$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }

    // Auto-submit when all digits entered
    if (index === 5 && value) {
      const otpString = newOtp.join('');
      if (otpString.length === 6) {
        setTimeout(() => onVerify(otpString), 100);
      }
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, 6);
    if (!/^\d+$/.test(pastedData)) return;

    const newOtp = pastedData.split('');
    while (newOtp.length < 6) newOtp.push('');
    setOtp(newOtp);

    // Focus last filled input or last input
    const nextIndex = Math.min(pastedData.length, 5);
    inputRefs.current[nextIndex]?.focus();

    // Auto-submit if complete
    if (pastedData.length === 6) {
      setTimeout(() => onVerify(pastedData), 100);
    }
  };

  const handleResend = () => {
    setOtp(['', '', '', '', '', '']);
    inputRefs.current[0]?.focus();
    alert('Code sent! (Demo: any 6-digit code works)');
  };

  return (
    <div className="screen-container">
      <button className="back-button" onClick={onBack}>←</button>
      
      <div className="content-card">
        <div className="logo-container">
          <div className="logo">H</div>
          <div className="logo-text">Homie</div>
          <p className="tagline">Track all your shippings in one place</p>
        </div>
        
        <div className="otp-container">
          <p className="otp-sent-to">
            Enter verification code for<br />
            <strong>{phoneNumber}</strong>
          </p>
          <p style={{ fontSize: '13px', color: '#999', marginTop: '8px', marginBottom: '16px' }}>
            Enter any 6-digit code
          </p>
          
          <div className="otp-inputs">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className="otp-input"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste}
              />
            ))}
          </div>
          
          <button className="resend-code" onClick={handleResend}>
            Resend Code
          </button>
          
          <button 
            className="submit-button"
            onClick={() => onVerify(otp.join(''))}
            disabled={otp.join('').length !== 6}
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
}

export default OTPVerification;
